<template>
  <div class="table-wrapper-scroll-y">
    <!--<h3 v-show="searchTaxi">找尋中...</h3>-->
    <table
      class="table table-striped jambo_table bulk_action table_style table-bordered"
    >
      <thead>
        <tr class="headings">
          <th class="column-title word_center">排序號</th>
          <th class="column-title word_center">隊編/呼號</th>
          <th class="column-title word_center">狀態</th>
          <th class="column-title word_center">回報位置</th>
          <th class="column-title word_center">速度</th>
          <th class="column-title word_center">地址</th>
          <th class="column-title word_center">回報時間</th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="pointer fontSize16 point text_hailing dropdown"
          v-for="(item, index) in data"
          @click="_setFocusMarker(item.lat, item.lng, index)"
        >
          <td class="word_center">{{ index + 1 }}</td>
          <td class="word_center">{{ callNumber }}</td>
          <td class="word_center">
            {{
              item.status === 0
                ? '休息'
                : item.status === 1
                  ? '空車'
                  : item.status === 2
                    ? '派遣中'
                    : item.status === 3
                      ? '載客中'
                      : item.status === 4
                        ? '排班中'
                        : item.status === 5
                          ? '登出'
                          : item.status === 6
                            ? '失聯'
                            : item.status === 7
                              ? '停權'
                              : '失聯'
            }}
          </td>
          <td class="word_center">{{ item.lat }}/{{ item.lng }}</td>
          <td class="word_center">{{ item.speed }}</td>
          <td class="word_center">{{ item.address }}</td>
          <td class="word_center">{{ item.time }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import API from '../../assets/js/libs/API'

export default {
  props: ['data', 'callNumber'],
  data() {
    return {
      istriggerEvent: false,
    }
  },
  methods: {
    _clickItemToSetAddress(index) {
      if (this.istriggerEvent) {
        this.$msg('稍等找尋中')
        return
      }
      this.istriggerEvent = true
      if (this.data[index].address !== undefined) this.$msg('已有資料')
      API.get(
        `service/address/near/?points=${this.data[index].lng},${this.data[index].lat}`,
      )
        .then((res) => {
          this.$set(this.data[index], 'address', res.result[0])
          this.istriggerEvent = false
        })
        .catch((err) => {
          this.$msg('連線失敗，再試一次')
          this.istriggerEvent = false
        })
    },
    _getAddress(index) {},
    _setFocusMarker(lat, lng, index) {
      let latlng = {
        latitude: lat,
        longitude: lng,
      }
      this._clickItemToSetAddress(index)
      this.$emit('setFocusMarker', latlng)
    },
  },
  watch: {
    status: function setStatus(status) {
      console.log(status)
      switch (status) {
        case 0:
          return '休息'
        case 1:
          return '空車'
        case 2:
          return '派遣中'
        case 3:
          return '載客中'
      }
    },
  },
}
</script>

<style scoped>
.table_style {
  overflow: auto;
  height: 200px;
}
.table-wrapper-scroll-y {
  display: block;
  max-height: 600px;
  overflow-y: auto;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
</style>



// WEBPACK FOOTER //
// src/pages/driver/TrajectoryList.vue